// Backend forecast datapoints carry a `DateOnly` ("yyyy-MM-dd"). `new Date(...)`
// parses that as UTC midnight, so local-time accessors report the previous or
// next day in any non-UTC timezone — enough to misfile a period-end datapoint
// (e.g. 31 Dec) into the following period. Parse the calendar parts directly so
// the resulting Date is local midnight on the intended day.

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export function parseDateOnly(value: string | Date): Date {
  if (value instanceof Date) return value;
  const match = DATE_ONLY_PATTERN.exec(value);
  if (!match) return new Date(value);
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function monthBucketKey(value: string | Date): string {
  const d = parseDateOnly(value);
  return `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
}

export function quarterBucketKey(value: string | Date): {
  key: string;
  year: number;
} {
  const d = parseDateOnly(value);
  const year = d.getFullYear();
  return { key: `Q${Math.floor(d.getMonth() / 3) + 1} ${year}`, year };
}

export function yearBucketKey(value: string | Date): number {
  return parseDateOnly(value).getFullYear();
}
